/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GpsWaypoint {
  key: number;
  latitude: number;
  longitude: number;
  hasAltitude: boolean;
  altitude: number;
  hasHeading: boolean;
  heading: number;
  hasGimbalPitch: boolean;
  gimbalPitch: number;
}

function createBaseGpsWaypoint(): GpsWaypoint {
  return {
    key: 0,
    latitude: 0,
    longitude: 0,
    hasAltitude: false,
    altitude: 0,
    hasHeading: false,
    heading: 0,
    hasGimbalPitch: false,
    gimbalPitch: 0,
  };
}

export const GpsWaypoint = {
  encode(message: GpsWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== 0) {
      writer.uint32(8).sint64(message.key);
    }
    if (message.latitude !== 0) {
      writer.uint32(17).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(25).double(message.longitude);
    }
    if (message.hasAltitude === true) {
      writer.uint32(32).bool(message.hasAltitude);
    }
    if (message.altitude !== 0) {
      writer.uint32(41).double(message.altitude);
    }
    if (message.hasHeading === true) {
      writer.uint32(48).bool(message.hasHeading);
    }
    if (message.heading !== 0) {
      writer.uint32(61).float(message.heading);
    }
    if (message.hasGimbalPitch === true) {
      writer.uint32(64).bool(message.hasGimbalPitch);
    }
    if (message.gimbalPitch !== 0) {
      writer.uint32(77).float(message.gimbalPitch);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.key = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.latitude = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.longitude = reader.double();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.hasAltitude = reader.bool();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.altitude = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.hasHeading = reader.bool();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.heading = reader.float();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.hasGimbalPitch = reader.bool();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.gimbalPitch = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GpsWaypoint {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      hasAltitude: isSet(object.hasAltitude) ? globalThis.Boolean(object.hasAltitude) : false,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : 0,
      hasHeading: isSet(object.hasHeading) ? globalThis.Boolean(object.hasHeading) : false,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      hasGimbalPitch: isSet(object.hasGimbalPitch) ? globalThis.Boolean(object.hasGimbalPitch) : false,
      gimbalPitch: isSet(object.gimbalPitch) ? globalThis.Number(object.gimbalPitch) : 0,
    };
  },

  toJSON(message: GpsWaypoint): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.hasAltitude === true) {
      obj.hasAltitude = message.hasAltitude;
    }
    if (message.altitude !== 0) {
      obj.altitude = message.altitude;
    }
    if (message.hasHeading === true) {
      obj.hasHeading = message.hasHeading;
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.hasGimbalPitch === true) {
      obj.hasGimbalPitch = message.hasGimbalPitch;
    }
    if (message.gimbalPitch !== 0) {
      obj.gimbalPitch = message.gimbalPitch;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsWaypoint>, I>>(base?: I): GpsWaypoint {
    return GpsWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsWaypoint>, I>>(object: I): GpsWaypoint {
    const message = createBaseGpsWaypoint();
    message.key = object.key ?? 0;
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.hasAltitude = object.hasAltitude ?? false;
    message.altitude = object.altitude ?? 0;
    message.hasHeading = object.hasHeading ?? false;
    message.heading = object.heading ?? 0;
    message.hasGimbalPitch = object.hasGimbalPitch ?? false;
    message.gimbalPitch = object.gimbalPitch ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
